import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useQuery } from '@apollo/client';
import useAuthentication from 'hooks/use-authentication';
import Loader from 'components/loader/loader';
import EXAM_ATTEMPT_QUERY from 'queries/exam-attempt.graphql';
import useNavigateForCompletedExam from 'hooks/use-navigate-exam-completed';
const PrivateRoute = ({ children, validateCompletedExam }) => {
    const location = useLocation();
    const { isLoggedIn, getUserIdFromToken, getExamIdFromToken, logout } = useAuthentication();
    if (!isLoggedIn()) {
        logout();
        return _jsx(Navigate, { to: '/login', state: { from: location } }, void 0);
    }
    const { redirectIfCompleted } = useNavigateForCompletedExam(undefined);
    const { data: examAttemptData, loading } = useQuery(EXAM_ATTEMPT_QUERY, {
        variables: {
            userId: getUserIdFromToken(),
            examId: getExamIdFromToken(),
        },
    });
    useEffect(() => {
        if (validateCompletedExam && (examAttemptData === null || examAttemptData === void 0 ? void 0 : examAttemptData.examAttempt)) {
            redirectIfCompleted(examAttemptData.examAttempt);
        }
    }, [examAttemptData]);
    {
        loading && _jsx(Loader, { isFullWith: true }, void 0);
    }
    return children;
};
export default PrivateRoute;
